import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Form } from '@anytag/shared-atoms';
import { TextSearchField, SingleDatePickerField } from '@anytag/shared-molecules';
import { TagsList, TagsListProps, TagsAnalyticsFilterFormKeys, TagsAnalyticsFilterFormValues } from '../../shared';
import { useCreateDeleteInstagramHashtag, useExportInstagramHashtagPosts } from './hooks';

export interface TemplateProps {
  countryId: string;
  hashtags: TagsListProps['tags'];
  onSubmit?: TagsListProps['onSubmit'];
}

export const Template = ({ hashtags, onSubmit, countryId }: TemplateProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<TagsAnalyticsFilterFormValues>();
  const [dateValue, tagIdValue] = watch(['date', 'tagId']);
  const { creating, deleting, handleCreateHashtag, handleDeleteHashtag } = useCreateDeleteInstagramHashtag({
    countryId
  });
  const { ExportButton, ExportModal } = useExportInstagramHashtagPosts({ hashtagId: String(tagIdValue) });

  return (
    <>
      <TagsList
        tags={hashtags}
        onSubmit={onSubmit}
        creating={creating}
        deleting={deleting}
        countryId={countryId}
        onCreateTag={handleCreateHashtag}
        onDeleteTag={handleDeleteHashtag}
      />

      <Form.Fields className="mt-2">
        <TextSearchField<TagsAnalyticsFilterFormKeys>
          name="keyword"
          onSubmit={onSubmit}
          placeholder={t<string>('hashtagsAnalyticsKeywordPlaceholder')}
        />

        <SingleDatePickerField<TagsAnalyticsFilterFormKeys>
          name="date"
          onSubmit={onSubmit}
          className="w-[184px] flex-none"
          disabledDays={{ after: new Date() }}
          required
          clearable={false}
        />

        <Form.Field className="flex-none">
          <ExportButton disabled={!dateValue || !tagIdValue} />
        </Form.Field>
      </Form.Fields>

      {ExportModal}
    </>
  );
};
